"use client";

import { motion } from "framer-motion";
import Image from "next/image";
import Link from "next/link";

export default function Navbar() {
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="sticky top-0 z-50 w-full border-b border-black/5 bg-white/80 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-2 px-4 py-3 sm:px-6 sm:py-4 lg:px-8">
        <Link href="/">
          <Image
            src="/logo2.png"
            alt="MedTechData Logo"
            width={180}
            height={32}
            className="h-6 w-auto shrink-0 object-contain sm:h-8"
          />
        </Link>
        <div className="flex shrink-0 items-center gap-1.5 sm:gap-3">
          <Link
            href="/login"
            className="shrink-0 whitespace-nowrap rounded-lg border border-black/10 px-2.5 py-1.5 text-xs font-medium text-ink transition-colors hover:bg-black/5 sm:px-4 sm:py-2 sm:text-sm"
          >
            Sign In
          </Link>
          <motion.div
            className="shrink-0"
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
          >
            <Link
              href="/signup"
              className="block shrink-0 whitespace-nowrap rounded-lg bg-brand px-2.5 py-1.5 text-xs font-medium text-white shadow-sm shadow-brand/30 transition-colors hover:bg-brand-dark sm:px-4 sm:py-2 sm:text-sm"
            >
              Sign up Free
            </Link>
          </motion.div>
        </div>
      </div>
    </motion.header>
  );
}
